import {setTimeout} from "timers";
<template></template>
<script>
import socketClient from "../../api/Client";
import * as dssRequest from "../../api/dssRequest";
import { mapGetters } from "vuex";
import QuadrantObject from "../../objects/QuadrantObject";
// import * as parser from "../../api/Parser";
import appConfig from "../../../config/app_config";
import BaseComponent from "../base/BaseComponent.vue";
import _ from "lodash";

export default {
  extends: BaseComponent,
  props: {
    properties: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      lastObject: null,
      webSocket: {},
      sessionId: "",
      token: "",
      dialog: false,
      objectsLinked: [],
      headers: [],
      signals: null,
      fullSize: this.properties.fullSize ? this.properties.fullSize : false,
      objectId: "",
      configDest: false,
      // it contains the last aspects snaposhot divide by type
      aspects: this.getAspectsStruct()
    };
  },
  computed: {
    getCustomHeight: function() {
      if (this.fullSize == true) {
        return "quadrant_full_height";
      }
      if (
        !_.isEmpty(this.properties.profile) &&
        this.properties.profile.style.height == "big" &&
        this.configDest == false
      ) {
        return "big_quadrant_height";
      }
      if (this.configDest == true) {
        return "config_quadrant_height";
      } else if (this.properties.profile.style.height == "small") {
        return "small_quadrant_height";
      } else {
        return "quadrant_height";
      }
    },
    ...mapGetters({
      dashboardStatus: "getDashboardStatus",
      _token: "auth/token"
    })
  },
  created() {

    window.EventBus.listen("generateSessionId", this.generateSessionId);
    window.EventBus.listen("enlarge", this.enlarge);
    window.EventBus.listen("dosmall", this.doSmall);
    window.EventBus.listen("configDestination", this.configDestTrue);
    window.EventBus.listen("defaultSize", this.configDestFalse);
  },
  mounted() {
    this.signals = this.properties.signalObjectMap;
    this.generateSessionId();

    if (
      !(
        !_.isEmpty(this.properties.profile) &&
        this.properties.profile.hasOwnProperty("connect") &&
        this.properties.profile.connect === false
      )
    ) {
      this.connect();
    } else {
    }
  },
  beforeDestroy() {

    if (
      !(
        !_.isEmpty(this.properties.profile) &&
        this.properties.profile.hasOwnProperty("connect") &&
        this.properties.profile.connect === false
      )
    ) {
      this.removeLinkListener();
      this.stopWebSocket();
    }
    window.EventBus.removeListener("configDestination", this.configDestTrue);
    window.EventBus.removeListener("defaultSize", this.configDestFalse);
    window.EventBus.removeListener("generateSessionId", this.generateSessionId);
    window.EventBus.removeListener("enlarge", this.enlarge);
    window.EventBus.removeListener("dosmall", this.doSmall);
  },
  methods: {
    getAspectsStruct() {
  return {
    UserAspectData: {},
    IncidentAspectData: {},
    SensorAspectData: {},
    ActuatorAspectData: {},
    AspectList: {},
    ProgressUpdateData: {}
  };
},
    enlarge(data) {
      this.fullSize = true;
      this.resizeComponent(data);
    },
    doSmall(data) {
      this.fullSize = false;
      this.resizeComponent(data);
    },
    configDestTrue(data) {
      this.configDest = true;
    },
    configDestFalse(data) {
      this.configDest = false;
    },
    addLinkListener() {
      if (
        !_.isEmpty(this.properties.profile) &&
        this.properties.profile.hasOwnProperty("relink") &&
        this.properties.profile.relink == true
      ) {
        window.EventBus.listen("linkToTreeObject", this.linkToTreeObject);
      }
    },
    removeLinkListener() {
      if (
        !_.isEmpty(this.properties.profile) &&
        this.properties.profile.hasOwnProperty("relink") &&
        this.properties.profile.relink == true
      ) {
        window.EventBus.removeListener(
          "linkToTreeObject",
          this.linkToTreeObject
        );
      }
    },
    generateSessionId(data = null) {
      if (data !== null) {
        this.signals = data;
        this.connect();
      }
      let _sessionId = this.$store.getters["auth/userName"];
      this.token = this._token;
      // if (appConfig.test) {
      //   if (_sessionId == "" || this.token == "" || this.token == null) {
      //     _sessionId = "development@thedrivingforce.nl";
      //     this.token =
      //       "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjdiZTQxN2M4NGIyNTM5MmRjZTU4ODQzMmI2M2MyMzZiMGZiZDY0MDA3NTUwYTE0NTA3YjYxMjdiYzdhY2UyZDQxMGJkY2MwZTkzMGFkODMwIn0.eyJhdWQiOiIzIiwianRpIjoiN2JlNDE3Yzg0YjI1MzkyZGNlNTg4NDMyYjYzYzIzNmIwZmJkNjQwMDc1NTBhMTQ1MDdiNjEyN2JjN2FjZTJkNDEwYmRjYzBlOTMwYWQ4MzAiLCJpYXQiOjE1MzMzMDgxMTIsIm5iZiI6MTUzMzMwODExMiwiZXhwIjoxNTY0ODQ0MTEyLCJzdWIiOiIxMDg2OSIsInNjb3BlcyI6WyIqIl19.HWNHo6rEyJvKgGnmpD-DTRNaE1JyH8oSVOMcLS2741QyomUbczyQoSCmoUkT4EmDvLSb0lnxVkIWknOYck_mLqJzcZfLkVKdXVoVeRdMHDtPVoOYQDEtYDhjud4Ce_ao50P6CdLxWvs7jy0EYzG61N5if5Xp9bt1SMzX5UixTUorNz1Sj0m-DHoLzcb3z3HLGhOVm-eQ1l7NwmmCUk9CawbGY3GN_fKQyweF1fP4s9HUGhr08lg9gFKZZ5R0HxtBLGTXcWLDVtaxVQw1LSMNDTN-m3xXWIyvu9ljc-rnJ9nMbJmj2O9b6VSqc4tS0ifsP4j59kZ8R3eroluTzU39RygRL__fACgZBFBe_T6M02UaLt6qjxpx9A_crjwFOUs5rF130d4FPCVnaybGuIBsAgpfGqBSG2U3r-fRQz87vLYArGk33gtNP21e6wnUsN98-yto7vz9d3bcpPmFnisJS7YFhDzhJ9pP7Py4R38Xli405HemlAcWYRWEmxwPo4BWFAPgefDiccnXWQkFRpLmOL-O6mOshYMt6HD6tBW51nmGcjJ5XdC99UXWCVwWkk4sJay21qY-ktOcXq0fpxmXUUE7LArQyPFPNAs6Ftc2G0RB5DRd8MmjPXWfuJVJ2m9yHaWcJInFZoT5zKj6KqdN147rak-kXpj-5CVOO6Zhd4E";
      //     this.$store.commit("auth/setToken", this.token);
      //   }
      // }
      this.sessionId = _sessionId +=
        "_" + this.$options.name + "_" + QuadrantObject._createPinCode();
      this.removeLinkListener();
      this.addLinkListener();
    },
    linkToTreeObject(data) {
      console.log(" LINKING ON BASEQ", data)
      let nuObj = data.id;
      if (this.lastObject != nuObj) {
        window.EventBus.fire("PreventReload", true);
        this.beforeCleanWebSocket(data);
        this.signals = this.getPlainSignalMap(nuObj);
        this.unlinkToAllSignals();
      }
      this.lastObject = nuObj;
    },
    getPlainSignalMap(object) {
      console.log("CHECK OBJECT", object)
      return new Map().set(object, [
        ["locationAspectUpdate", ["LocationAspectData"]],
        ["incidentAspectUpdate", ["IncidentAspectData"]],
        ["userAspectUpdate", ["UserAspectData"]],
        ["routeAspectUpdate", ["RouteAspectData"]],
        ["CapacityUpdate", ["CapacityData"]],
        ["userLocationUpdate", ["userLocationData"]]


      ]);
    },
    beforeCleanWebSocket() {
    },
    resizeComponent(data) {
    },
    reconnect() {
      this.connect();
    },
    connect() {
      this.createWebSocket();
    },
    createWebSocket(data = null) {
      if (data !== null ) {
        this.signals = data;
      }
      this.webSocket = new socketClient(
        this.onBaseEvent,
        this.sessionId,
        this._token,
        this.signals,
        this.onConnectionStatus
      );
      this.webSocket.start(this.autoConnect);
    },
    unlinkToAllSignals() {
      if (this.objectsLinked.length > 0) {
        for (let obj in this.objectsLinked) {
          this.doUnlinkAndDisconnect(this.objectsLinked[obj]);
        }
      }
    },
    stopWebSocket() {
      this.webSocket.stop(true);
    },
    autoConnect() {
      this.objectsLinked = [];
      if (this.signals != undefined && this.signals.size > 0) {
        this.signals.forEach((value, key, map) => {
          this.doLinkAndConnect(key, value);
        });
      } else {
        console.warn("No specified signals for component ", this.sessionId);
      }
    },
    onConnectionStatus(event) {
      console.warn("onConnectionStatus", this.sessionId, event == "CloseEvent");
      // How do we check a proper close from a disconnect ?
      if (event == null) {
        this.generateSessionId();
        return this.sessionId;
      }
    },
    onBaseEvent(data) {
      if (data.Name == "CapacityUpdate") {
        data.Data.EventId = data.Source
        window.EventBus.fire("recievedNewCapacityData", data.Data);
      }
      this.onEvent({ data: data });
    },
    onPreEvent({
      data: data,
      signal: signal,
      intersectionAspectList: intersectionAspectList,
      toBeDeletedAspectList: toBeDeletedAspectList,
      toBeAddedAspectList: toBeAddedAspectList
    }) {
      // joins the add, update aspects in aspects internal object

      this.onEvent({
        data: data,
        signal: signal,
        intersectionAspectList: intersectionAspectList,
        toBeDeletedAspectList: toBeDeletedAspectList,
        toBeAddedAspectList: toBeAddedAspectList
      });
    },
    onEvent(container) {
      const data = container.data;
    },
    addObject(data) {
    },
    doDisconnectSignalsList(object, signalsList) {
      let payload = Object.assign({}, this.webSocket.args);
      request.signals = {
        datatype: "table"
      };
      signalsList.forEach((signal, index) => {
        request.signals["sig" + index] = {
          datatype: "string",
          value: signal
        };
      });
      dssRequest.doRequest(
        response => {
          console.log("The call for doDisconnect was successful", response);
        },
        error => {
          console.warn("The call for doDisconnect was not successful", error);
        },
        "disconnect",
        object,
        payload
      );
    },
    doLinkAndConnect(object, signalsList) {
      console.log(
        "doLinkAndConnect ",
        this.sessionId,
        object,
        signalsList,
        this.objectsLinked,
        this.webSocket.args
      );
      if (signalsList[0][0] !== 'locationAspectUpdate') {
        if (!this.objectsLinked.includes(object)) {
          let request = JSON.parse(JSON.stringify(this.webSocket.args));
          request.signals = {
            // datatype: "table"
          };
          signalsList.forEach((signal, index) => {
            request.signals["sig" + index] = signal[0];
            // {
            // datatype: "string",
            // value: signal[0]
            // };
          });
          // dssRequest.doLinkAndConnect(
          //   response => {
          //     this.objectsLinked.push(object);
          //     this.objectId = object;
          //     this.onLinkReply(object, response);
          //   },
          //   error => {
          //     console.warn("doLinkAndConnect error", this.sessionId, error);
          //     this.onLinkReply(object, error);
          //     this.objectId = object;
          //   },
          //   object,
          //   request
          // );
        }
      }
    },
    doUnlinkAndDisconnect(object) {
      console.log(
        "doUnlinkAndDisconnect ",
        this.sessionId,
        object,
        this.objectsLinked
      );
      const request = Object.assign({}, this.webSocket.args);
      // dssRequest.doUnlinkAndDisconnect(
      //   response => {
      //     this.removeLinkedObjectFromArray(object);

      //     this.objectId = "";
      //     this.autoConnect();
      //     // console.log("doUnlinkAndDisconnect response remove", index);
      //   },
      //   error => {
      //     this.removeLinkedObjectFromArray(object);
      //     console.warn(
      //       "doUnlinkAndDisconnect error",
      //       this.sessionId,
      //       object,
      //       error
      //     );
      //     this.onUnlinkReply(object, error);
      //     this.autoConnect();
      //   },
      //   object,
      //   request
      // );
    },
    removeLinkedObjectFromArray(object) {
      const index = this.objectsLinked.indexOf(object);
      if (index > -1) {
        this.objectsLinked.splice(index, 1);
      }
    },
    onRegistered(status) {
    },
    onLinkReply(object, returnData) {
      window.EventBus.fire("PreventReload", false);
    },
    onUnlinkReply(object, returnData) {

      window.EventBus.fire("PreventReload", false);
    }
  }
};
</script>
